import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css"; // <-- Make sure this line is present!
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);